import common from "../../common.copyText";

/* prettier-ignore */
export default {
  ...common,
  addFilterButtonLabel: "Add Filter",
  addTargetButtonLabel: "Add Target",
  addTenantButtonLabel: "Add Tenant",
  adjustToListInputLabel: "Adjust to List",
  allTenantsLabel: "All",
  appliesToAllLabel: "Applies to all",
  applyToAllTenantsInputLabel: "Apply to all tenants?",  
  backToBillingRulesEngineButtonLabel: "Back to Billing Rules Engine",
  backToCostAllocationsButtonLabel: "Back to Cost Allocations",
  billingRulesPageTitle: "Billing Rules Engine",
  costAllocationsPageTitle: "Cost Allocations",
  costDestinationSectionDescription: "Only costs within the specified date range will be reallocated.",
  costDestinationSectionTitle: "Cost Destination",
  costDestinationTooltipMessage: "Define how filtered costs are split across targets — by fixed shares or usage-based metrics.",
  costOriginSectionDescription: "Only costs within the specified date range will be reallocated.",
  costOriginSectionTitle: "Cost Origin",
  costOriginTooltipMessage: "Choose which original costs to reallocate using filters like provider, account, SKU, or labels. Only matching line items will be included.",
  createRuleButtonLabel: "Create Rule",
  createRuleFormTitle: "Create Rule",
  createRuleTooltipContent: "Create a rule that will be applied each time your billing data is updated in Ternary.",
  deleteRuleModalMessage: "This will permenantly delete the rule. Are you sure you want to do this?",
  deleteRuleModalTitle: "Delete Rule",
  detailsSectionTitle: "Details",
  editRuleFormTitle: "Edit Rule",
  endDateInputLabel: "End Date",
  errorCreatingBillingRuleMessage: "An error occurred while attempting to create the billing rule. Please try again.",
  errorDeletingBillingRuleMessage: "An error occurred while attempting to delete the billing rule. Please try again.",
  errorLoadingBillingRulesMessage: "There was an error loading billing rules. Please try again.",
  errorUpdatingBillingRuleMessage: "An error occurred while attempting to update the billing rule. Please try again.",
  filtersSectionLabel: "Filters",
  labelsSectionTitle: "Labels",
  nameInputLabel: "Name",
  nameInputPlaceholder: "Add Name",
  newBillingRuleLabel: "New",
  operatingMarginInputLabel: "Operating Margin",
  percentageInputLabel: "Percentage",
  presentDateLabel: "Present",
  reallocationTypeOptionLabel_DYNAMIC: "Dynamically Weighted",
  reallocationTypeOptionLabel_STATIC: "Statically Weighted",
  rerateInputLabel: "Rerate",
  rulePrioritySectionCaption: "Rules are applied in order of priority. The highest priority rule will be applied first.",
  rulePrioritySectionTitle: "Rule Priority",
  rulePriorityTooltipMessage: "Set the order in which this rule runs when multiple rules could apply to the same cost.",
  ruleSectionTitle: "Rule",
  ruleTypeOptionLabel_ADJUST_TO_LIST: "Adjust to List",
  ruleTypeOptionLabel_APPLY_MARGIN: "Operating Margin",
  ruleTypeOptionLabel_BACKOUT_LINE_ITEM: "Back out Line Item",
  ruleTypeOptionLabel_REALLOCATE_COSTS: "Reallocate Costs",
  ruleTypeOptionLabel_RERATE: "Rerate",
  selectTenantsPlacholder: "Select Tenants...",
  setRulePriorityInputLabel: "Set Rule Priority",
  startDateInputLabel: "Start Date",
  successCreatingBillingRuleMessage: "The billing rule has been successfully created.",
  successDeletingBillingRuleMessage: "The billing rule has been successfully deleted.",
  successUpdatingBillingRuleMessage: "The billing rule has been successfully updated.",
  tableHeaderCreatedBy: "Created By",
  tableHeaderDateRange: "Date Range",
  tableHeaderExecutionOrder: "Execution Order",
  tableHeaderLastModified: "Last Modified",
  tableHeaderName: "Name",
  tableHeaderTenants: "Tenants",
  targetsSectionTitle: "Targets",
  tenantsSectionTitle: "Tenants",
  typeInputLabel: "Type",
  validationErrorMessageSelectAtLeastOneTenant: "Please select at least one tenant",
  weightingKeysSectionTitle: "Weighting Keys",
};
